export const REQUEST_ADD_NEW_TEMPLATE = "REQUEST_ADD_NEW_TEMPLATE";
export const REVOKE_ADD_NEW_TEMPLATE = "REVOKE_ADD_NEW_TEMPLATE";
export const RESET_ADD_NEW_TEMPLATE = "RESET_ADD_NEW_TEMPLATE";
export const GRANT_ADD_NEW_TEMPLATE = "GRANT_ADD_NEW_TEMPLATE";

export const SET_NEW_TEMPLATE_TYPE = "SET_NEW_TEMPLATE_TYPE";
export const RESET_NEW_TEMPLATE_TYPE = "RESET_NEW_TEMPLATE_TYPE";

export const SET_NEW_SMS_TEMPLATE_TITLE = "SET_NEW_SMS_TEMPLATE_TITLE";
export const RESET_NEW_SMS_TEMPLATE_TITLE = "RESET_NEW_SMS_TEMPLATE_TITLE";

export const SET_NEW_EMAIL_TEMPLATE_TITLE = "SET_NEW_EMAIL_TEMPLATE_TITLE";
export const RESET_NEW_EMAIL_TEMPLATE_TITLE = "RESET_NEW_EMAIL_TEMPLATE_TITLE";

export const SET_NEW_EMAIL_TEMPLATE_CONTENT = "SET_NEW_EMAIL_TEMPLATE_CONTENT";
export const RESET_NEW_EMAIL_TEMPLATE_CONTENT =
  "RESET_NEW_EMAIL_TEMPLATE_CONTENT";

export const SET_NEW_EMAIL_TEMPLATE_HTML = "SET_NEW_EMAIL_TEMPLATE_HTML";
export const RESET_NEW_EMAIL_TEMPLATE_HTML = "RESET_NEW_EMAIL_TEMPLATE_HTML";

export const SET_NEW_SMS_TEMPLATE_MESSAGE = "SET_NEW_SMS_TEMPLATE_MESSAGE";
export const RESET_NEW_SMS_TEMPLATE_MESSAGE = "RESET_NEW_SMS_TEMPLATE_MESSAGE";

export const SET_NEW_SMS_TEMPLATE_PLAINTEXT = "SET_NEW_SMS_TEMPLATE_PLAINTEXT";
export const RESET_NEW_SMS_TEMPLATE_PLAINTEXT =
  "RESET_NEW_SMS_TEMPLATE_PLAINTEXT";
